import React from 'react';

// title + subtitle + right-aligned actions — the block atop every list page
// (currently hand-written per page with small drift in title size/weight
// and subtitle color). `actions` takes whatever the page needs on the
// right (refresh icon, primary "New" button, filters) rather than
// prescribing a fixed set, since that varies more page to page than the
// title/subtitle treatment does. `icon` covers the other common variant —
// a form-style page (Ad-Hoc, Announce) titled with a leading icon instead
// of right-aligned actions.
export default function PageHeader({ title, subtitle, actions, icon: Icon }) {
  return (
    <div className="flex items-center justify-between gap-3 mb-5">
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          {Icon && <Icon size={20} className="text-blue-700 flex-shrink-0" />}
          <h1 className="text-xl font-bold text-gray-900 truncate">{title}</h1>
        </div>
        {subtitle && <p className="text-xs text-gray-400 mt-0.5">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
    </div>
  );
}
